import { take, switchMap, map, startWith } from 'rxjs/operators';
import { from, lastValueFrom, of, BehaviorSubject, Observable } from 'rxjs';
import { MaterialProductAPI } from 'src/app/apis/material_product.service';
import { ProductAPI } from 'src/app/apis/product.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
// import { appConfig } from '../config/app-config';
import { dev } from '../config/offlines_keys.json';
import routes from '../config/routing.json';
import { ProgramasAPI } from '../apis/programas.service';
import { Store } from '@ngrx/store';
import Owner from '../models/owner.model';
import { cloneDeep } from 'lodash';
import {
  getAppConfig,
  getCountry,
} from './states-management/selector/countries.selector';
import { MORPH_MaterialCategorie, MORPH_Product } from './consts';
import { appConfig } from '../config/app-config-equator';

@Injectable({ providedIn: 'root' })
export class RoutingConfig {
  constructor(
    private router: Router,
    private ProductAPI: ProductAPI,
    private materialProductAPI: MaterialProductAPI,
    private programAPI: ProgramasAPI,
    private store: Store<{ owner: Owner }>
  ) {
    this.setupOwnerSubscription();
  }
  owner;
  setupOwnerSubscription() {
    this.ownerSubscription = this.store.select('owner').subscribe(owner => {
      this.ownerChange$.next(owner);

      this.owner = cloneDeep(owner);
      // Filter routing config based on owner profile info
      this.filterRoutingConfigByOwner(owner);

      // this.updateRoutingConfig();
    });
  }

  /**
   * Filters routing configuration based on owner profile information
   * @param owner - The owner object containing profile_info
   */
  filterRoutingConfigByOwner(owner: any) {
    if (owner && owner?.profile_info) {
      let profile_info = JSON.parse(owner?.profile_info);
      this.cropProducts = profile_info?.cropConfig;

      // Filter out partner route if no crop products
      if (this.cropProducts && this.cropProducts?.length == 0) {
        this.routingConfig = this.routingConfig?.filter((element) => {
          return element?.route != '/partner';
        });

      }

      // Filter by role if role exists
      if (profile_info?.role) {
        this.routingConfig = this.routingConfig?.filter((element) => {
          return !element?.exist_in_role || element?.exist_in_role && element?.exist_in_role?.includes(profile_info.role);
        });

      }
    }
    // this.routingConfigSubject$.next(this.routingConfig);

    return this.routingConfig;
  }

  async getComponentConfig() {
    await this.getConfigObject();
    return this.routingConfig || [];
  }

  // updateRoutingConfig() {
  //   this.ownerChange$.pipe(
  //     // take(1),
  //     switchMap(owner => {
  //       if (owner && owner.profile_info && owner.profile_info.role) {
  //         return from(this.getComponentConfig()).pipe(
  //           map(config => {
  //             const filteredConfig = config.filter((element) => {
  //               return (
  //                 element.ownerRole == owner.profile_info.role &&
  //                 element.cropProducts == this.cropProducts
  //               );
  //             });
  //             return filteredConfig;
  //           })
  //         );
  //       }
  //       return of([]);
  //     })
  //   ).subscribe(filteredConfig => {
  //     this.routingConfigSubject$.next(filteredConfig);
  //     this.navigationConfigSubject$.next(filteredConfig);
  //   });
  // }
  landingProgress;
  appConfig: any;
  public routingConfig: any;
  cropProducts;
  cropConfig;

  // Reactive infrastructure
  public routingConfigSubject$ = new BehaviorSubject<any[]>(null);
  private navigationConfigSubject$ = new BehaviorSubject<any[]>(null);
  private ownerSubscription;
  private ownerChange$ = new BehaviorSubject<Owner>(null);

  async getNextUrl() {

    const filteredConfig = await this.filterRoutingConfigByOwner(this.owner);
    if (filteredConfig && filteredConfig.length > 0) {
      const currentIndex = filteredConfig.findIndex((element) => {
        return element.route.includes(this.router.url);
      });

      // If current route is found and there's a next route
      if (currentIndex !== -1 && currentIndex < filteredConfig.length - 1) {
        return filteredConfig[currentIndex + 1]?.route;
      }
    }
    return null;
  }


  async getBackUrl() {
    const filteredConfig = await this.filterRoutingConfigByOwner(this.owner);
    if (filteredConfig && filteredConfig.length > 0) {
      const currentIndex = filteredConfig.findIndex((element) => {
        return element.route.includes(this.router.url);
      });

      // If current route is found and there's a previous route
      if (currentIndex !== -1 && currentIndex > 0) {
        return filteredConfig[currentIndex - 1]?.route;
      }
    }
    return null;
  }



  async getLandingProgress() {
    const filteredConfig = await this.filterRoutingConfigByOwner(this.owner);
    if (filteredConfig) {
      let routeIndex = filteredConfig.findIndex((element) => {
        return (
          element.route == this.router.url ||
          (element.route.includes(this.router.url) &&
            !this.router.url.includes('/person'))
        );
      });

      if (routeIndex > 1 && routeIndex != filteredConfig.length - 2) {
        this.landingProgress = routeIndex / filteredConfig.length;
        return this.landingProgress;
      } else if (routeIndex == filteredConfig.length - 2) {
        return 1;
      } else if (routeIndex == -1) {
        return routeIndex;
      } else {
        return 0;
      }
    } else {
      return null;
    }
  }

  // crop config
  async getCropFormConfig() {
    this.appConfig = await this.getConfigObject();
    if (this.appConfig) {
      this.cropConfig = this.appConfig.cropConfig;
      return this.appConfig.cropConfig;
    } else return null;
  }

  //dashboard  config
  async getDashboardConfig() {
    await this.getConfigObject();
    return this.appConfig.dashboard;
  }

  //landing header config
  async getLandingRoutingConfig() {
    // Return the filtered routing configuration
    const filteredConfig = await this.filterRoutingConfigByOwner(this.owner);

    return filteredConfig || this.routingConfig;
  }
  async getProfileFormConfig() {
    await this.getConfigObject();
    return this.appConfig != null ? this.appConfig.profileConfig : null;
  }
  async getMenuFormConfig() {
    await this.getConfigObject();

    return this.appConfig != null ? this.appConfig.menuConfig : null;
  }
  async getPageFormConfig(component_name = '') {
    let isDashboardView = this.router.url === '/' + routes.dashboard.profile;
    let config;
    await this.getConfigObject();

    if (isDashboardView || component_name) {
      config = this.routingConfig?.find((element) => {
        if (element?.component_name) {
          return element?.component_name == component_name;
        } else return false;
      });
    } else {
      config = this.routingConfig.find((element) => {
        return element.route.includes(this.router.url);
      });
    }

    return config?.formConfig;
  }

  async getConfigObject() {
    let APP_CONFIG = await lastValueFrom(this.store.select(getAppConfig).pipe(take(1)))
    // let APP_CONFIG = appConfig;
    // 

    if (APP_CONFIG) {
      this.appConfig = APP_CONFIG;
      this.routingConfig = this.appConfig.landing.routingConfig;
      return this.appConfig;
    }
    return null;
  }


  async getListProgrammesConfig() {
    await this.getConfigObject();
    let country = await lastValueFrom(
      this.store.select(getCountry).pipe(take(1))
    );
    var programmes = await this.programAPI
      .getProgramasByCountryID(country.id)
      .toPromise();

    var vote = await this.programAPI.getVotes().toPromise();
    if (vote) {
      programmes.forEach((prog) => {
        var exist = vote?.find((el) => el.programas_id === prog.id);
        if (exist) {
          prog.checked = true;
          prog.vote = exist;
          prog.stars = Array(parseInt(prog.vote?.stars_number));
        } else {
          prog.checked = false;
          prog.vote = null;
          prog.stars = Array();
        }
      });
    }

    if (programmes && programmes.length > 0) {
      programmes.forEach((prog) => {
        prog.config = this.appConfig?.programmes?.programmesConfig?.find(
          (p) => p.programme_id == prog.id
        );
      });
    }

    return programmes;
  }

  async saveCropProductListToStorage() {
    await this.getCropFormConfig();

    this.ProductAPI.getProductById(this.cropConfig?.crop_id)
      .pipe(
        take(1),
        switchMap((products: any) => {
          products.map((value) => {
            value.morph = 'App\\Models\\Product';
          });
          this.cropProducts = products;
          return of(products);
        }),
        switchMap(async (value) => {
          if (this.cropConfig?.material_category_crop_id) {
            return this.materialProductAPI.getAllAnimalCategories();
          } else {
            return of(value);
          }
        }),
        switchMap((element) => element),
        map(async (val: any) => {
          if (
            this.cropConfig &&
            Array.isArray(this.cropConfig?.material_category_crop_id) &&
            this.cropConfig?.material_category_crop_id[0] &&
            val
          ) {
            var animal = val.find(
              (category: any) =>
                category?.id == this.cropConfig?.material_category_crop_id[0]
            );
            let animalProduct = animal?.childrens.find(
              (child) => child?.id == this.cropConfig?.material_crop_id[0]
            );
            animalProduct.material_category_id =
              this.cropConfig?.material_category_crop_id[0];
            animalProduct.morph = 'App\\Models\\MaterialCategorie';
            this.cropProducts.push(animalProduct);
            return of(this.cropProducts);
          }
        })
      )
      .subscribe(async (data: any) => {
        await Preferences.set({
          key: dev.CROP_PRODUCT,
          value: JSON.stringify(this.cropProducts),
        });
      });
  }
}
